// 新source 下单和课程详情页
export const EVENT_ID_CREATE_LEADSID = '10083425092724736';
export const EVENT_ID_PAGE_LEARN_LEADSID = '10083427157370880';
// 课程卡片点击事件
export const EVENT_ID_COURSE_CARD_CLICK = '34210505';
